
import { CheckCircle2 } from "lucide-react";

interface OrderConfirmationHeaderProps {
  orderNumber: number;
  customerName: string;
  customerEmail: string;
  shippingAddress: string;
}

export const OrderConfirmationHeader = ({ 
  orderNumber,
  customerName,
  customerEmail,
  shippingAddress
}: OrderConfirmationHeaderProps) => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="text-center space-y-3 sm:space-y-4">
        <div className="inline-block p-2 sm:p-3 bg-green-100 rounded-full">
          <CheckCircle2 className="w-10 h-10 sm:w-12 sm:h-12 text-green-600" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-green-600">
          Commande confirmée !
        </h1>
        <p className="text-gray-600 max-w-lg mx-auto text-sm sm:text-base">
          Votre commande #{orderNumber} a été confirmée. Pour finaliser votre achat, veuillez effectuer le virement du montant exact indiqué ci-dessous.
        </p>
      </div>

      <div className="bg-gray-50 rounded-lg p-4 sm:p-6 space-y-3 sm:space-y-4">
        <h2 className="font-semibold text-gray-900">Détails de livraison</h2>
        <div className="grid gap-3 sm:gap-4 text-sm">
          <div>
            <p className="font-medium text-gray-700">Nom</p>
            <p className="text-gray-600">{customerName}</p>
          </div>
          <div>
            <p className="font-medium text-gray-700">Email</p>
            <p className="text-gray-600 break-words">{customerEmail}</p>
          </div>
          <div>
            <p className="font-medium text-gray-700">Adresse de livraison</p>
            <p className="text-gray-600">{shippingAddress}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
